// @mui
import Card from '@mui/material/Card';
// routes
// hooks
import { useProfile } from 'src/hooks/use-profile';
// _mock
import { _userAbout, _userFeeds } from 'src/_mock';
// components
//
import { Box } from '@mui/material';
import ProfileCover from '../profile-cover';
import ProfileHome from '../profile-home';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export default function UserProfileView() {

  const { profile: user } = useProfile();


  return (
    <Box >
      <Card
        sx={{
          mb: 3,
          height: 290,
        }}
      >
        <ProfileCover
          role={user?.user_type}
          name={user?.displayName}
          avatarUrl={user?.photoURL || user.image}
          coverUrl={_userAbout.coverUrl}
        />

      </Card>

      <ProfileHome info={user}  />

    </Box>
  );
}
